export default "__VITE_ASSET__CJ$stb9T__"